import deepMerge from 'deepmerge';

import dashboard from '@bundles/Dashboard/translations';
import inviteUser from '@bundles/InviteUser/translations';
import privacyPolicy from '@bundles/PrivacyPolicyPage/translations';
import mappingEditPage from '@bundles/Registrations/ConversionToolSettings/EditPage/translations';
import mappingPage from '@bundles/Registrations/ConversionToolSettings/MappingPage/translations';
import jurisdictionsListPage from '@bundles/Registrations/JurisdictionsListPage/translations';
import importGameChangerModal from '@pages/Filing/GameChangerPage/components/ImportGameChangerModal/translations';
import troubleshootPage from '@pages/Filing/TroubleshootPage/translations';
import handleImportGameChanger from '@sagas/gameChanger/handleImportGameChanger/translations';
import accountSettings from '@translations/pages/account-settings';
import apisPage from '@translations/pages/api-page';
import changePassword from '@translations/pages/change-password';
import gameChanger from '@translations/pages/gameChanger';
import generalErrors from '@translations/pages/general-error';
import inviteExpiry from '@translations/pages/invite-expiry';
import notFound from '@translations/pages/not-found';

import creditNote from './creditNote';
import draftReturnPage from './draft-return';
import errorPage from './error-page';
import filingPage from './filing-page';
import fixErrorsPage from './fix-errors-page';
import forgotPassword from './forgot-password';
import intrastatPage from './intrastat-page';
import logPage from './log-page';
import manageUsers from './manage-users';
import manualTaxCodes from './manual-tax-codes';
import messages from './messages';
import onlineSpreadsheet from './online-spreadsheet';
import orgStructure from './org-structure';
import processingPage from './processing-page';
import registrationsPermissions from './registrations-permissions';
import summaryPage from './summary-page';
import taxCodesPage from './tax-codes';
import taxCodeDetails from './taxCodeDetails';
import uploadDataPage from './upload-data';

export default deepMerge.all([
  accountSettings,
  apisPage,
  changePassword,
  creditNote,
  dashboard,
  draftReturnPage,
  errorPage,
  filingPage,
  fixErrorsPage,
  forgotPassword,
  gameChanger,
  generalErrors,
  handleImportGameChanger,
  importGameChangerModal,
  intrastatPage,
  inviteExpiry,
  inviteUser,
  jurisdictionsListPage,
  logPage,
  manageUsers,
  manualTaxCodes,
  mappingEditPage,
  mappingPage,
  messages,
  notFound,
  onlineSpreadsheet,
  orgStructure,
  privacyPolicy,
  processingPage,
  registrationsPermissions,
  summaryPage,
  taxCodeDetails,
  taxCodesPage,
  troubleshootPage,
  uploadDataPage,
]);
